import numbro from 'numbro';

numbro.setLanguage('en-US');
